import { gql } from './generated/gql';

const RESOLVE_THREAD_MUTATION = gql(`
  mutation resolveThread($id: ID!) {
    resolveThread(threadId: $id) {
      id
    }
  }
`);

export default RESOLVE_THREAD_MUTATION;
